// reducer.js
import {
  GET_SHIFTS,
  GET_SHIFTS_SUCCESS,
  GET_SHIFTS_FAIL,
  ADD_SHIFTS,
  ADD_SHIFTS_SUCCESS,
  ADD_SHIFTS_FAIL,
  UPDATE_SHIFTS,
  UPDATE_SHIFTS_SUCCESS,
  UPDATE_SHIFTS_FAIL,
  DELETE_SHIFTS,
  DELETE_SHIFTS_SUCCESS,
  DELETE_SHIFTS_FAIL,
  SET_SHIFT_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  shifts: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const shiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHIFTS:
      return { ...state, loading: true }
    case GET_SHIFTS_SUCCESS:
      return { ...state, loading: false, shifts: action.payload }
    case GET_SHIFTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_SHIFTS:
      return { ...state, loading: true }
    case ADD_SHIFTS_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} } // Clear field errors on success
    case ADD_SHIFTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_SHIFTS:
      return { ...state, loading: true }
    case UPDATE_SHIFTS_SUCCESS:
      return {
        ...state,
        loading: false,
        fieldErrors: {}, // Clear field errors on success
      }
    case UPDATE_SHIFTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_SHIFTS:
      return { ...state, loading: true }
    case DELETE_SHIFTS_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_SHIFTS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_SHIFT_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default shiftReducer